export default __webpack_public_path__ + "static/media/homebg.41fc685f.jpg";